/* eslint-disable react-hooks/exhaustive-deps */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import { axios, Constants, Globals } from '../../../utils';
import { Select, Button, SelectActions, Input } from '../../../components';
import { useState } from 'react';
import { useEffect } from 'react';

export class ModalProducts extends Component {

  state = {
    page: 1,
    last_page: 1,
    form: {
      search: '',
      user_id: this.props.user.id,
      quantity: '',
      discount: '',
      warehouse_id: "",
    },
    data: [],
    prices: [],
    selectedProduct: null,
    selectedPrice: '',
    warehouses: this.props.warehouses,
    formatWarehouses: this.props.formatWarehouses,
    config: null, // Agregado para paridad con modulo normal
    fiscal: true,
  }

  componentDidMount() {
    this.load();
    this.getConfig(); // Agregado
  }

  // Agregado para obtener la config real del usuario (igual que en Normal)
  getConfig = () => {
    axios
      .post("sync/config", { user_id: this.props.user.id })
      .then(({ data }) => {
        this.setState({ config: data.config });
      })
      .catch(() => Globals.showError())
      .finally(() => Globals.quitLoading());
  };

  load = async () => {
    if (this.props.user.level_id == Constants.ROLE_ADMIN) {
      this.onSelectWarehouse(this.props.user.warehouse_principal);
    }
    else {
      if (this.props.user.warehouse_id == null) {
        this.onSelectWarehouse(this.props.user.warehouse_principal);
      }
      else {
        this.onSelectWarehouse(this.props.user.warehouse_id)
      }
    }
  }

  getproducts = async () => {
    Globals.setLoading();

    const form = {
      search: this.state.form.search,
      user_id: this.state.form.user_id,
    };

    axios.post("web/admin/orders/products", form)
      .then(res => {
        if (!res.data) throw Error('No se encontraron los productos');
        this.setState({ data: res.data.products });
      })
      .catch(() => {
        Globals.showError();
      })
      .finally(() => Globals.quitLoading());
  }

  resetForm = async () => {
    await this.setState({
      form: {
        search: '',
        user_id: this.props.user.id,
        quantity: '',
        discount: '',
        warehouse_id: this.state.form.warehouse_id,
      },
      prices: [],
      selectedProduct: null,
      selectedPrice: '',
    });
  }

  change = async (value, target) => {
    await this.setState(state => ({ form: { ...state.form, [target]: value } }));
  }

  onChangeProductSizeColor = async (value, target) => {
    await this.setState(state => ({
      selectedProduct: {
        ...state.selectedProduct,
        [target]: value,
      }
    }));

    this.setPrices();
    this.formatProduct();
  }

  formatProduct = () => {
    const { form, selectedPrice, selectedProduct } = this.state;
    if (!selectedProduct) return;

    const quantity = Number(form.quantity);
    const discount = Number(form.discount || 0);
    const warehouse_id = Number(form.warehouse_id)
    let stock = selectedProduct.stock;

    if (selectedProduct.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
      const size_color = selectedProduct.size_colors.find(sc => sc.size_id === selectedProduct.size_id && sc.color_id === selectedProduct.color_id);

      stock = size_color?.stock || 0;
      selectedProduct.altName = selectedProduct.name;
      if (!!size_color?.color) selectedProduct.altName += `, ${size_color.color.name}`;
      if (!!size_color?.size) selectedProduct.altName += `, ${size_color.size.name}`;
    }

    const subtotal = quantity * selectedPrice;

    this.setState({
      selectedProduct: {
        ...selectedProduct,
        product_id: selectedProduct.id,
        quantity,
        stock,
        subtotal,
        discount,
        warehouse_id,
      }
    });
  }

  getPrices = (product) => {
    let size_color = null;
    let prices = product.prices;

    if (product?.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
      size_color = product?.size_colors?.find((i) => {
        if (product.size_id && product.color_id) {
          return i.size_id === product.size_id && i.color_id === product.color_id;
        }
        else if (product.size_id) {
          return i.size_id === product.size_id && !i.color_id;
        }
        else if (product.color_id) {
          return i.color_id === product.color_id && !i.size_id;
        }

        return null;
      });

      prices = size_color?.prices || [];
      product.price = (product?.size_colors.length > 0 ? product?.size_colors[0].sale_price : 0);

    } else {
      product.price = product.sale_price;
    }

    console.log('size_color?.sale_price || product.price', size_color?.sale_price || product.price)
    console.log('prices', prices)

    // REPLICADO EXACTO DEL NORMAL: Usamos Globals.formatMiles(..., true)
    return [
      {
        value: parseFloat(size_color?.sale_price || product.price),
        label: `$${Globals.formatMiles(parseFloat(size_color?.sale_price || product.price).toFixed(2), true)}`,
      },
      ...(prices || []).map(i => ({
        value: parseFloat(i.price),
        label: `$${Globals.formatMiles(parseFloat(i.price).toFixed(2), true)}`,
      }))
    ]
  }

  setPrices = async () => {
    const product = Globals.copy(this.state.selectedProduct);
    this.setState({
      prices: this.getPrices(product),
      selectedPrice: '',
    });
  }

  onSelectProduct = async (id) => {
    await this.resetForm();
    const selectedProduct = Globals.copy(this.state.data.find(p => p.id === id));
    let prices = this.getPrices(selectedProduct);
    selectedProduct.size_id = null;
    selectedProduct.color_id = null;

    await this.setState(state => ({
      selectedProduct,
      selectedPrice: '',
      prices,
      form: {
        ...state.form,
        quantity: '',
        discount: '',
      }
    }));

    this.formatProduct();
  }

  onSelectPrice = async (amount) => {
    let decimal = 2
    if (this.props.user?.config?.three_decimals === Constants.STATUS_ACTIVE) {
      decimal = 3;
    }
    await this.setState({ selectedPrice: parseFloat(parseFloat(amount).toFixed(decimal)) });
  }

  onSelectWarehouse = async (warehouse_id) => {
    this.setState(state => ({
      form: {
        ...state.form,
        warehouse_id: warehouse_id,
      }
    }));

    Globals.setLoading();
    try {
      const data = {
        web: true,
        user_id: this.props.user.id,
        is_select: true,
        warehouse_id: warehouse_id,
        with_products: true,
        unique_by_size_color: true,
      };

      const res = await axios.post('web/admin/warehouses', data);

      if (res.data && res.data.warehouses && res.data.warehouses.length > 0) {
        const selectedWarehouse = res.data.warehouses[0];

        if (selectedWarehouse && selectedWarehouse.products) {
          const products = selectedWarehouse.products.map(i => {
            const total_quantity = i.total_quantity;

            // Replicado del normal: chequeo de negative_stock
            if (this.state.config?.negative_stock == Constants.CONFIG.NO) {
              if (total_quantity <= 0) {
                return null;
              }
            }

            return {
              ...i.product,
              total_quantity: total_quantity
            };
          }).filter(product => product !== null);
          this.setState({ data: products });
        } else {
          this.setState({ data: [] });
        }
      } else {
        this.setState({ data: [] });
      }
    } catch (error) {
      console.log('Error fetching warehouse products: ', error);
      Globals.showError('Error al cargar los productos del almacén');
    } finally {
      Globals.quitLoading();
    }
  }

  onChangeQuantity = async (value) => {
    await this.change(value, 'quantity');
    this.formatProduct();
  }

  submit = () => {
    if (!this.isValidForm()) return;

    const product = Globals.copy(this.state.selectedProduct);
    product.name = product?.altName || product.name;
    product.price = this.state.selectedPrice;
    product.sale_price = this.state.selectedPrice;
    product.selected_price = this.state.selectedPrice;

    this.props.onSelectProduct(product, this.state.form.warehouse_id);
    this.resetForm();
  }

  isValidForm = () => {
    const onError = (msg) => {
      Globals.showError(msg);
      return false;
    }

    const { selectedPrice, selectedProduct } = this.state;

    if (!selectedProduct)
      return onError('Debe seleccionar el producto');

    if (selectedProduct.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
      let colors = selectedProduct.size_colors.filter(i => i.color_id).reduce((prev, curr) => prev.set(curr.color_id, curr.color), new Map()).values();
      let sizes = selectedProduct.size_colors.filter(i => i.size_id).reduce((prev, curr) => prev.set(curr.size_id, curr.size), new Map()).values();
      colors = [...colors];
      sizes = [...sizes];

      if (!!colors.length && !selectedProduct.color_id)
        return onError('Debe seleccionar un color');

      if (!!sizes.length && !selectedProduct.size_id)
        return onError('Debe seleccionar una talla');
    }

    if (!selectedProduct)
      return onError('Debe selecciona el producto');

    if (typeof selectedPrice !== 'number')
      return onError('Debe seleccionar el precio');

    if (selectedProduct.discount !== '' && selectedProduct.discount < 0)
      return onError('El porcentaje de descuento no puede ser negativo');

    if (selectedProduct.discount !== '' && selectedProduct.discount > 100)
      return onError('El porcentaje de descuento no puede ser mayor a 100%');

    if (selectedProduct?.decimal_stock == Constants.DECIMAL_STOCK.NO) {
      if (selectedProduct.quantity < 1)
        return onError('Debe seleccionar al menos 1');
    } else {
      if (selectedProduct.quantity <= 0)
        return onError('Debe ingresar la cantidad');
    }

    // Validar stock por talla/color seleccionada (para productos SIZE_COLOR)
    if (selectedProduct.type === Constants.PRODUCTS_TYPE.SIZE_COLOR) {
      const size_color = selectedProduct.size_colors?.find(sc =>
        (selectedProduct.size_id && selectedProduct.color_id
          ? sc.size_id === selectedProduct.size_id && sc.color_id === selectedProduct.color_id
          : selectedProduct.size_id
          ? sc.size_id === selectedProduct.size_id && !sc.color_id
          : selectedProduct.color_id
          ? sc.color_id === selectedProduct.color_id && !sc.size_id
          : false)
      );
      const sizeStock = size_color?.stock ?? 0;
      if (sizeStock <= 0) {
        return onError(`La talla/color seleccionada no tiene stock disponible`);
      }
      if (this.state.config?.negative_stock == Constants.CONFIG.NO && selectedProduct.quantity > sizeStock) {
        return onError(`No hay suficiente stock para esta talla/color (${sizeStock} disponibles)`);
      }
    } else {
      // Replicado del normal: Validación de stock vs negative_stock
      if (this.state.config?.negative_stock == Constants.CONFIG.NO) {
        if (selectedProduct.warehouse_id === this.props.user.warehouse_principal) {
          if (selectedProduct.quantity > selectedProduct.stock) {
            return onError(`No hay suficiente stock (${selectedProduct.stock})`);
          }
        }
        else {
          if (selectedProduct.quantity > selectedProduct.total_quantity) {
            return onError(`No hay suficiente stock (${selectedProduct.total_quantity})`);
          }
        }
      }
    }

    return true;
  }

  render() {

    const { form, data, prices, selectedProduct, selectedPrice } = this.state;

    return (
      <div className="mt-2">
        {(
          (
            this.state.warehouses.length > 1 && (
              this.props.user.level_id == Constants.ROLE_ADMIN ||
              (this.props.user.level_id == Constants.ROLE_MODERATOR && this.props.user.warehouse_id === null)
            )
          ) ?
            <div className="col-12 select-product">
              <Select
                label="Almacén"
                labelClass="material"
                disabledFirst
                value={form.warehouse_id}
                options={this.state.formatWarehouses}
                onChange={e => this.onSelectWarehouse(e.target.value)}
              />
            </div>
            : ''
        )}

        <div className="col-12 select-product">
          <SelectActions
            label="Nombre o Código"
            isSearchable
            options={data.map(item => ({
              ...item,
              value: item.id,
              label: `${String(item.code).toLowerCase().toUpperCase()} - ${item.name}`,
              actions: [],
            }))}
            value={selectedProduct?.id || null}
            onChange={this.onSelectProduct}
          />
        </div>

        {selectedProduct?.type === Constants.PRODUCTS_TYPE.SIZE_COLOR && (
          <div className="col-12">
            <SizeColorForm
              product={selectedProduct}
              onChange={(value, target) => this.onChangeProductSizeColor(value, target)}
            />
          </div>
        )}

        <div className="col-12 price-discount">
          <div className="select-price">
            <Select
              label="Precio"
              labelClass="material"
              disabledFirst
              value={selectedPrice}
              options={prices}
              onChange={e => this.onSelectPrice(e.target.value)}
            />
          </div>

          <div className="select-discount">
            <Input
              label="Descuento (%)"
              placeholder="Opcional"
              type="number"
              color=" "
              className="material"
              labelClass="material"
              step="0.01"
              min="0"
              max="100"
              value={form.discount}
              onChange={async (e) => {
                await this.change(e.target.value, 'discount');
                if (!!selectedProduct) this.formatProduct();
              }}
            />
          </div>
        </div>

        <div className="container-data">
          <span>Cantidad</span>
          <NumberFormat
            className="quantity-input"
            placeholder="0"
            value={form.quantity}
            allowEmptyFormatting={true}
            decimalScale={selectedProduct?.decimal_stock == Constants.DECIMAL_STOCK.YES ? 2 : 0}
            thousandSeparator="."
            decimalSeparator=","
            allowNegative={false}
            onValueChange={({ floatValue }) => this.onChangeQuantity(floatValue || "")}
            isAllowed={({ floatValue }) => {
              if (floatValue === undefined) return true;
              return selectedProduct?.decimal_stock == Constants.DECIMAL_STOCK.YES ? true : floatValue % 1 === 0;
            }}
          />
        </div>

        <div className="actions">
          <Button onClick={() => this.submit()}>
            CARGAR
          </Button>

          <Button onClick={() => this.props.onClose()}>
            FINALIZAR
          </Button>
        </div>
      </div>
    )
  }
}

const SizeColorForm = ({ product, onChange }) => {

  const [colors, setColors] = useState([]);
  const [sizes, setSizes] = useState([]);

  function getUniqueItems() {
    const _colors = product.size_colors.filter(i => i.color_id).reduce((prev, curr) => prev.set(curr.color_id, curr.color), new Map());
    const _sizes = product.size_colors.filter(i => i.size_id).reduce((prev, curr) => prev.set(curr.size_id, curr.size), new Map());

    setColors([..._colors.values()]);
    setSizes([..._sizes.values()]);
  }

  useEffect(() => {
    getUniqueItems();
  }, []);

  // Helper: obtener el stock de una talla (considerando color si aplica)
  function getSizeStock(size) {
    if (!product || !product.size_colors) return null;
    const matches = product.size_colors.filter(sc => sc.size_id === size.id);
    if (matches.length === 0) return null;
    if (product.color_id) {
      const specific = matches.find(sc => sc.color_id === product.color_id);
      return specific ? (specific.stock ?? 0) : null;
    }
    return matches.reduce((acc, sc) => acc + (sc.stock ?? 0), 0);
  }

  function getColorStock(color) {
    if (!product || !product.size_colors) return null;
    const matches = product.size_colors.filter(sc => sc.color_id === color.id);
    if (matches.length === 0) return null;
    if (product.size_id) {
      const specific = matches.find(sc => sc.size_id === product.size_id);
      return specific ? (specific.stock ?? 0) : null;
    }
    return matches.reduce((acc, sc) => acc + (sc.stock ?? 0), 0);
  }

  return (
    <div className="size-colors-form">
      {!!sizes.length && (
        <div className="sizes">
          <Select
            label="Talla"
            labelClass="material"
            className="material"
            disabledFirst
            options={sizes.map(item => {
              const stock = getSizeStock(item);
              const noStock = stock !== null && stock <= 0;
              return {
                value: item.id,
                label: noStock ? `${item.name} (sin stock)` : item.name,
                disabled: noStock,
              };
            })}
            value={product.size_id}
            onChange={e => onChange(Number(e.target.value), 'size_id')}
          />
        </div>
      )}

      {!!colors.length && (
        <div className="colors">
          <SelectActions
            label="Color"
            options={colors.map(item => {
              const stock = getColorStock(item);
              const noStock = stock !== null && stock <= 0;
              return {
                value: item.id,
                label: noStock
                  ? (<span style={{ opacity: 0.4 }}><div className="circle" style={{ backgroundColor: item.hex, display: 'inline-block' }} /> (sin stock)</span>)
                  : (<div className="circle" style={{ backgroundColor: item.hex }} />),
                actions: [],
                isDisabled: noStock,
              };
            })}
            value={product.color_id}
            onChange={id => onChange(Number(id), 'color_id')}
          />
        </div>
      )}
    </div>
  );
}

export default connect(state => ({
  user: state.user,
}))(ModalProducts)